import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";

const CATEGORIES = [
  {
    no: "01",
    title: "AI Kits",
    slug: "ai-kits",
    desc: "Prompt packs and workflows designed for real daily use.",
    note: "Prompts · Playbooks · Cheatsheets",
  },
  {
    no: "02",
    title: "Templates",
    slug: "templates",
    desc: "Clean templates for writing, planning, content, and productivity.",
    note: "Notion · Docs · Sheets",
  },
  {
    no: "03",
    title: "Workflows",
    slug: "workflows",
    desc: "Step-by-step systems that help you move from idea to finished output.",
    note: "Routines · Checklists · Systems",
  },
];

const Categories = () => {
  return (
    <section
      id="products"
      data-testid="section-categories"
      className="bg-white border-y border-[#E7E7E2]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-24 md:py-32">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-end">
          <div className="lg:col-span-7">
            <div className="overline">— What Vaymilo makes</div>
            <h2 className="mt-5 font-sora text-[36px] sm:text-[44px] lg:text-[56px] font-bold text-[#111111] tracking-tight leading-[1.05]">
              Digital kits that make
              <br className="hidden sm:block" /> work easier.
            </h2>
          </div>
          <div className="lg:col-span-5">
            <p className="font-manrope text-[16px] md:text-[17px] text-[#111111]/65 leading-relaxed">
              Three small categories, no clutter. Each item is built to feel
              calm to use and useful from the first minute.
            </p>
          </div>
        </div>

        <div className="mt-14 md:mt-20 grid grid-cols-1 md:grid-cols-3 gap-px bg-[#E7E7E2] border border-[#E7E7E2] rounded-2xl overflow-hidden">
          {CATEGORIES.map((c) => (
            <Link
              key={c.title}
              to={`/products?category=${c.slug}`}
              data-testid={`category-${c.slug}`}
              className="group bg-white p-8 md:p-10 flex flex-col min-h-[260px] transition-colors hover:bg-[#F7F7F4]"
            >
              <div className="flex items-center justify-between">
                <span className="font-mono text-xs text-[#111111]/45">
                  {c.no}
                </span>
                <ArrowUpRight
                  size={18}
                  className="text-[#111111]/30 group-hover:text-[#2563EB] transition-colors"
                />
              </div>
              <h3 className="mt-8 font-sora text-[26px] md:text-[28px] font-semibold text-[#111111] tracking-tight">
                {c.title}
              </h3>
              <p className="mt-3 font-manrope text-[15px] text-[#111111]/65 leading-relaxed">
                {c.desc}
              </p>
              <div className="mt-auto pt-8 font-mono text-[11px] tracking-[0.14em] uppercase text-[#111111]/40">
                {c.note}
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Categories;
